<template>
    <div>
        <first />
        <second />
        <third />
    </div>
</template>

<script src="./logistics.js"></script>
<style src="./logistics.css"></style>